// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EX1t","buttons":"styles_buttons__2OGOT"};